import React from 'react';
import listQuery from '../../../graphql/queries/company/IsoCountryListQuery.graphql';
import { EntityType, IDropdownOptionRenderer } from '../../../@types/entityTypes';
import { IIsoCountry } from '../../schema/p4types';

const IsoCountryOptionRenderer: IDropdownOptionRenderer = ({ option }: { option: IIsoCountry }) => {
  return (
    <span>
      {option.codeAlpha3} {option.name}
    </span>
  );
};

const IsoCountry: EntityType = {
  type: 'IsoCountry',
  title: 'ISO Country Codes',
  formTitle: 'ISO Country Code',
  formUrl: undefined,
  workspaceUrl: undefined,
  instance: undefined,
  workspace: undefined,
  update: undefined,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'codeAlpha3',
    optionRenderer: IsoCountryOptionRenderer,
    remoteFilter: true,
    preLoad: true,
  },
  screenReference: 'ISO_COUNTRY_CODES',
};

export default IsoCountry;
